import styled from 'styled-components';
import DropdownArrow from '@Shared/DropdownArrow';
import MenuButton from '@Shared/MenuButton';
import DropDown from '@Shared/DropdownContent';

export const StyledAccountCircle = styled.div`
  fill: ${props => props.theme.carvana.blue.dark};
  margin-right: 10px;
  height: 24px;
  width: 22px;
`;
export const StyledDropDown = styled(DropDown)`
  min-width: 253px;
  right: -18px;
  top: 66px;
  border-radius: 3px;
  z-index: 999;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
  ${props => props.isDropdownExpanded && 'display: block;'};

  &:after {
    right: 12px;
  }
`;
export const StyledArrowDropDown = styled(DropdownArrow)`
  fill: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.blue.dark)};
  margin-top: 1px;
  width: 9px;
`;
export const MenuTitle = styled.span`
  color: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.blue.dark)};
  font-size: 16px;
  font-weight: 400;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    max-width: none;
  }
`;
export const DropDownButton = styled(MenuButton)`
  justify-content: flex-start;
  letter-spacing: 0.1px;
  min-height: 50px;
  padding: 14px 19px;
  width: 100%;
`;
export const AccountWrapper = styled.div`
  display: inline-flex;
  height: 60px;
  position: relative;
  ${props => props.isDropdownExpanded && 'z-index: 101;'};
`;
export const OutsideClickWrapper = styled.div`
  display: none;
  ${props => props.isDropdownExpanded && 'display: block;'};
  background: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
`;

export const GoogleOneTapForceSignoutWrapper = styled.div``;
